export const Colors = {
  background: {
    primary: '#0a0e1a',
    secondary: '#1a1f2e',
    tertiary: '#252b3d',
    overlay: 'rgba(10, 14, 26, 0.85)',
  },

  surface: {
    sunken: '#0f1423',
    base: '#161d30',
    raised: '#1f273c',
    overlay: 'rgba(15, 20, 35, 0.72)',
  },

  text: {
    primary: '#F9FAFB',
    secondary: '#9CA3AF',
    tertiary: '#6B7280',
  },

  accent: {
    primary: '#3B82F6',
    secondary: '#60A5FA',
    tertiary: '#2563EB',
    highlight: '#93C5FD',
  },

  ai: {
    primary: '#00D9FF',
    secondary: '#00A8CC',
    accent: '#7AF2FF',
    glow: 'rgba(0, 217, 255, 0.2)',
  },

  market: {
    profit: '#10B981',
    loss: '#EF4444',
    neutral: '#9CA3AF',
  },

  status: {
    success: '#10B981',
    warning: '#F59E0B',
    error: '#EF4444',
    info: '#3B82F6',
  },

  border: {
    default: '#374151',
    active: '#3B82F6',
    subtle: '#1F2937',
    focus: '#00D9FF',
  },

  shadow: {
    small: 'rgba(0, 0, 0, 0.3)',
    medium: 'rgba(0, 0, 0, 0.4)',
    large: 'rgba(0, 0, 0, 0.5)',
  },
} as const;
